import { Domaine } from './domaine.model';

export class JsonData{
    public status: string;
    public code: number;
    public message: string;
    public data ?= [];
    // public datas ?: Domaine[];

}